import HeaderBig from '../../components/Header/Big/HeaderBig';
import BigWork from './Big/BigWork';
import styles from './Work.module.css';
import FooterDesktop from '../../components/Footer/FooterDesktop/FooterDesktop';
import WorkMain from './WorkMain/WorkMain';

const Work = () => {
  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);

  return (
    <div className={styles.container}>
      <HeaderBig className={styles.header} />

      <WorkMain />

      <main className={styles.main}>
        <BigWork />

        <FooterDesktop />
      </main>
    </div>
  );
};

export default Work;
